import './RenderSettingsDrawer.scss';

import { Drawer } from 'antd';
import type {
  LabeledValue,
  ParsedConfigurationItem,
  RenderSettingsScope,
  RenderSettingsType
} from 'common/models';
import { getRenderSettingsScopeTypeValue } from 'helpers/renderSettings';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

import RenderSettingsDrawerContent from './RenderSettingsDrawerContent';

interface Props {
  closable?: boolean;
  scope: RenderSettingsScope;
  type: RenderSettingsType;
  optionsToHide?: string[];
  parsedConfigurationItem?: ParsedConfigurationItem;
  onClose: () => void;
  open: boolean;
  onConfirm: (fieldIds: string[]) => void;
  openInSettings?: boolean;
  // Use for dynamic options, like serivceObjectRevisionCategories
  additionalOptions?: LabeledValue[];
}

const RenderSettingsDrawer: React.FC<Props> = (props): React.ReactElement => {
  const {
    closable,
    scope,
    type,
    optionsToHide,
    parsedConfigurationItem,
    onClose,
    open,
    onConfirm,
    openInSettings,
    additionalOptions
  } = props;

  const { t } = useCustomTranslation();

  return (
    <Drawer
      open={open}
      closable={closable}
      onClose={onClose}
      placement="right"
      rootClassName="RenderSettingsDrawer"
      className="RenderSettingsDrawer"
      size={400}
      destroyOnHidden
      title={t('renderSettings.title')}
    >
      <RenderSettingsDrawerContent
        onConfirm={onConfirm}
        scope={scope}
        optionsToHide={optionsToHide}
        selectedFields={getRenderSettingsScopeTypeValue(
          scope,
          type,
          undefined,
          parsedConfigurationItem
        )}
        enableReset={parsedConfigurationItem?.isUserSpecific}
        handleClose={onClose}
        openInSettings={openInSettings}
        additionalOptions={additionalOptions}
      />
    </Drawer>
  );
};

export default RenderSettingsDrawer;
